
import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton
} from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel, FormHelperText } from '@mui/material';

import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';

const CreateCategory = () => {
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', user_role: '' });
  const [editId, setEditId] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchCategories = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/getCatecory`);
    
    setCategories(response.data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);


  const handleOpen = (category = null) => {
    setOpen(true);
    if (category) {
      setEditId(category.id);
      setFormData({ name: category.name, user_role: category.user_role });
    } else {
      setEditId(null);
      setFormData({ name: '', user_role: '' });
    }
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    //console.log("editId====",editId);
    if (editId) {
      await axios.put(`${API_BASE_URL}/api/categories/categoryupdate/${editId}`, formData);
    } else {
      await axios.post(`${API_BASE_URL}/api/categories/categorystore`, formData);
    }
    fetchCategories();
    handleClose();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      await axios.delete(`${API_BASE_URL}/api/categories/${id}`);
      fetchCategories();
    }
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={() => handleOpen()}>
        Add Category
      </Button>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>User Role</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((category) => (
              <TableRow key={category.id}>
                <TableCell>{category.id}</TableCell>
                <TableCell>{category.name}</TableCell>
                <TableCell>{category.user_role}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpen(category)}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(category.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editId ? 'Edit Category' : 'Add Category'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Name"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          {/* <TextField
            margin="dense"
            label="User Role"
            fullWidth
            value={formData.user_role}
            onChange={(e) => setFormData({ ...formData, user_role: e.target.value })}
          /> */}
          
          <FormControl fullWidth margin="dense">
            <InputLabel id="user-role-label">User Role</InputLabel>
            <Select
                labelId="user-role-label"
                id="user-role"
                value={formData.user_role}
                onChange={(e) => setFormData({ ...formData, user_role: e.target.value })}
                label="User Role"
            >
                <MenuItem value="super_admin">Admin</MenuItem>
                <MenuItem value="provider">Provider</MenuItem>
                <MenuItem value="patient">Patient</MenuItem>
                <MenuItem value="vendor">Vendor</MenuItem>
                {/* Add more roles as needed */}
            </Select>
            {/* Optional helper text */}
            {/* <FormHelperText>Choose a role</FormHelperText> */}
            </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} color="primary">{editId ? 'Update' : 'Add'}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CreateCategory;
